import { render, staticRenderFns } from "./DispatchForm.vue?vue&type=template&id=f292cce6&scoped=true&"
import script from "./DispatchForm.vue?vue&type=script&lang=tsx&"
export * from "./DispatchForm.vue?vue&type=script&lang=tsx&"
import style0 from "./DispatchForm.vue?vue&type=style&index=0&id=f292cce6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f292cce6",
  null
  
)

export default component.exports